import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  title: t.Str,
  goFacebook: t.Func,
  goGoogle: t.Func,
  goTwitter: t.Func,
  goMicrosoft: t.Func,
  goLogin: t.maybe(t.Func)
})
export default class SocialLogins extends React.Component {

  goFacebook = (evt) => {
    evt.preventDefault();
    this.props.goFacebook();
  }

  goGoogle = (evt) => {
    evt.preventDefault();
    this.props.goGoogle();
  }

  goTwitter = (evt) => {
    evt.preventDefault();
    this.props.goTwitter();
  }

  goMicrosoft = (evt) => {
    evt.preventDefault();
    this.props.goMicrosoft();
  }

  goLogin = (evt) => {
    evt.preventDefault();
    this.props.goLogin();
  }

  getMadaiLogin() {
    if (!this.props.goLogin) {
      return null;
    }

    return (<div id="go_madai_login" onClick={this.goLogin} title="Madai"></div>);
  }

  render() {
    
    /* <div id="go_twitter_login" onClick={this.goTwitter} title="Twitter"></div> */
          
    return (
      <div id="logins" className="box light">
        <h2>{this.props.title}</h2>
        <div id="logins-container">
          <div id="go_google_login" onClick={this.goGoogle} title="Google"></div>
          <div id="go_microsoft_login" onClick={this.goMicrosoft} title="Microsoft"></div>
          {this.getMadaiLogin()}
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/SocialLogins.js
 **/